import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-what-is-hld-insurance',
  standalone: false,
  templateUrl: './what-is-hld-insurance.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})

export class WhatIsHLDInsuranceComponent {
  readonly dialogRef = inject(MatDialogRef<WhatIsHLDInsuranceComponent>);

  constructor() {
  }

  close() {
    this.dialogRef.close(false);
  }
}
